import { render, staticRenderFns } from "./SocietyContactsListView.vue?vue&type=template&id=474630d3&scoped=true"
import script from "./SocietyContactsListView.vue?vue&type=script&lang=js"
export * from "./SocietyContactsListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474630d3",
  null
  
)

export default component.exports